import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
@Component({
  selector: 'app-itgrid',
  templateUrl: './itgrid.component.html',
  styleUrls: ['./itgrid.component.scss']
})
export class ITgridComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }

  verifyemployee(data:any){
    this.appservice.ItFacilityEditdata=data;
    this.router.navigate(['/home/accountcreation'])
  }
  ngOnInit(): void {
    this.appservice.IT_CreationGrid_Data();
  }

}